import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const StartupTNPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      // heroTitle="A Feature-Rich App Built for"
      // heroGradientText="Networking and Navigation"
      clientLogo="/images/startup-white.png"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      infoLabel5="Website"
      visitWebsite="Visit Site"
      website="https://startuptn.in/"
      client="StartupTN"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      overviewTitle="Overview"
      // approachTitle="Approach"
      heroImage="/images/startuptn-first.png"
      overviewImage="/images/startuptn-first.png"
      approachImage="/images/startuptn-full.jpeg"
      overviewDescription={[
        'The website www.startuptn.in serves as the primary digital gateway for startups and innovators in Tamil Nadu, acting as a central hub where aspiring entrepreneurs can access a wide range of resources and services. From registering a new venture and applying for state-sponsored funding to exploring incubation opportunities and connecting with mentors, the portal simplifies the often complex processes of starting and scaling a business. Beyond administrative functions, it also provides guidance on policy frameworks, eligibility criteria for various schemes, and updates on the latest initiatives aimed at fostering innovation across the state. By consolidating these tools in a single, accessible platform, the website empowers entrepreneurs to navigate the ecosystem efficiently, reduce barriers to entry, and focus on turning ideas into sustainable enterprises.'
      ]}
      approachDescription={[
        'Beyond registration and funding, the site features ecosystem‑building tools and resources: information on events, incubators, industry‑linkages, and mentoring networks. For example, the site links into initiatives that help early‑stage companies build visibility and credibility, and connects them with domain experts and industry partners. This makes the website not just transactional but also a strategic hub for growth and networking.',
        'For founders in Tamil Nadu—especially those looking to bridge native talent with global reach—www.startuptn.in offers both opportunity and visibility. By leveraging the state’s formal support through the portal, entrepreneurs gain an institutional anchor behind their ventures. In this way, the website becomes more than a “government page” — it becomes a launch‑pad that ties together local heritage, modern scaling ambitions, and a structured path to influence.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      gradientTextStyle={styles.gradientText}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      // approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default StartupTNPage;
